import store from '@/store';
import { IStoreReady } from '@/store/lib/storeSupport';
import { Action, getModule, Module, Mutation, MutationAction, VuexModule } from 'vuex-module-decorators';
import { INews, INewsListItem,  NewsResponseType} from '@/entity/Settings/news.types';
import {PaginationRequestType} from "@/entity/common/pagination.types";
import {ResponseDataType} from "@/form/form.types";
import { prepareFormData } from '@/store/utils/formDataHelper';
import { SiteNewsRequestType } from '@/form/Settings/site/news.types';
import { SiteNewsUpdateRequestType } from '@/form/Settings/site/newsUpdate.types.';

@Module({
    namespaced: true,
    name: 'news',
    store,
    dynamic: true
})

class NewsModule extends VuexModule implements IStoreReady  {
    news: INews | null = null
    newsItem: INewsListItem | null = null
    newsLoaded = false
    newsItemLoaded = false
    ready = false

    @MutationAction
    async fetchAll(data?: PaginationRequestType): Promise<{ news: INews;  newsLoaded: boolean }> {
        let newsLoaded = false;
        const news = await store.$repository.news.fetchAll(prepareFormData(data));
        if(news){
            newsLoaded = true;
        }
        return { news, newsLoaded}
    }

    @MutationAction
    async fetchData(data?: PaginationRequestType): Promise<{ newsItem: INewsListItem;  newsItemLoaded: boolean }> {
        let newsItemLoaded = false;
        const newsItem = await store.$repository.news.fetchData(prepareFormData(data));
        if(newsItem){
            newsItemLoaded = true;
        }
        return { newsItem, newsItemLoaded}
    }

    @Action({rawError: true})
    async create(data: SiteNewsRequestType): Promise<ResponseDataType> {
        return await store.$repository.news.create(data);
    }
    @Action({rawError: true})
    async update(data: SiteNewsUpdateRequestType): Promise<ResponseDataType> {
        return await store.$repository.news.update(data);
    }
    @Action({rawError: true})
    async delete(data: {id: number}): Promise<ResponseDataType> {
        return await store.$repository.news.delete(data);
    }
    @Mutation
    setReady(st:boolean){
        this.ready = st
    }
    
}

export const NewsStore = getModule(NewsModule);